import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isDealRentCianAgency: TComputedPropMapper<boolean> = ({
  offer: { offerInDeal },
  isCianDealRentExperiment,
}) => Boolean(isCianDealRentExperiment && offerInDeal);
